export const createLink = (ref, amount, uid) => {
  return `https://a2apay.co.uk/pis-tokenrequest?reference=${ref}&amount=${amount}&uid=${uid}`;
};
